import { years } from "@/types/year";

/** Upload template headers by field. Validation and the locations download both match these exact names. */
export const SEVERITIES_TEMPLATE_KEYS = {
  id: "user_supplied_id (optional)",
  latitude: "latitude (required)",
  longitude: "longitude (required)",
  elevation: "elevation (optional)",
} as const;

/** Columns of the Severities upload template. */
export const SEVERITIES_TEMPLATE_HEADERS: string[] = Object.values(SEVERITIES_TEMPLATE_KEYS);

/** Year selection requested for every run. */
export const SEVERITIES_YEAR_SELECTION = "quinquennial";

/** The years `SEVERITIES_YEAR_SELECTION` returns: 1990 to 2100 in steps of 5. */
export const SEVERITIES_YEARS = years;

/** Hazards requested with return periods. Each gets its own results file in a download. */
export const SEVERITIES_HAZARDS = [
  "coastal_inundation",
  "cyclone_storm_surge",
  "cyclone_wind",
  "flood_riverine",
  "flood_surfacewater",
  "heat",
  "wind",
] as const;

export type SeveritiesHazard = (typeof SEVERITIES_HAZARDS)[number];

/** Each hazard's severity unit, as a `terms:units` key. */
export const SEVERITIES_HAZARD_UNITS: Record<SeveritiesHazard, "celsius" | "metres" | "metresPerSecond"> = {
  coastal_inundation: "metres",
  cyclone_storm_surge: "metres",
  cyclone_wind: "metresPerSecond",
  flood_riverine: "metres",
  flood_surfacewater: "metres",
  heat: "celsius",
  wind: "metresPerSecond",
};

/** Hazards that take the defences and anomaly management settings. */
export const SEVERITIES_OPTION_HAZARDS: readonly SeveritiesHazard[] = [
  "coastal_inundation",
  "cyclone_storm_surge",
  "flood_riverine",
  "flood_surfacewater",
];
